import styled from 'styled-components';
export const ContactMethodsContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}px;
  width: 100%;
`;
export const ContactMethodsHeader = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}px;
  padding-block-end: ${({ theme }) => theme.spacing.md}px;
  position: relative;
  width: 100%;
`;
export const ContactMethodsDivider = styled.div `
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey_1};
  bottom: 0;
  left: 0;
  position: absolute;
  width: 100%;
`;
export const ContactMethodsList = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xl}px;
  width: 100%;
`;
export const ContactMethodRowContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}px;
  width: 100%;
`;
export const ContactMethodRowHeader = styled.div `
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.sm}px;
  width: 100%;
`;
